import ContentComponent from './Content/Content'
import FooterComponent from './Footer/Footer'
import HeaderComponent from './Header/Header'

export const Content = ContentComponent
export const Footer = FooterComponent
export const Header = HeaderComponent

